import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import * as XLSX from 'xlsx';

import { ExcelPreviewDialogComponent } from '@components';
import { UtilService } from '@services';
import {
  createVehicleBatch,
  fetchVehicleBatches,
  processVehicleBatch,
  selectVehicleBatches,
  selectVehicleBatchesFetchedAt,
} from '@state/vehicle';

@Component({
  selector: 'app-vehicle-batch-upload',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDialogModule,
  ],
  templateUrl: './vehicle-batch-upload.component.html',
  styleUrl: './vehicle-batch-upload.component.scss',
})
export class VehicleBatchUploadComponent implements OnInit {
  columns: string[] = [
    'uploadDate',
    'uploadedBy',
    'fileName',
    'totalRecords',
    'processedCount',
    'failedCount',
    'status',
    'actions',
  ];

  $batchesFetchedAt = this.store.select(selectVehicleBatchesFetchedAt);
  $batches = this.store.select(selectVehicleBatches);
  message: any;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private store: Store,
    private dialog: MatDialog,
    public utils: UtilService
  ) {}

  ngOnInit(): void {
    this.store.dispatch(fetchVehicleBatches());
  }

  public onBatchUploadClicked(): void {
    this.fileInput.nativeElement.click();
  }

  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.previewFile(file);
    }
  }

  private previewFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const dialogRef = this.dialog.open(ExcelPreviewDialogComponent, {
        width: '90%',
        maxWidth: '95vw',
        data: { fileName: file.name, previewData: jsonData },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'upload') {
          this.store.dispatch(createVehicleBatch({ file }));
        }
        this.fileInput.nativeElement.value = '';
      });
    };
    reader.readAsArrayBuffer(file);
  }

  public downloadFile(url: string): void {
    window.open(url);
  }

  public processBatchUpload(batchId: string): void {
    this.store.dispatch(processVehicleBatch({ batchId }));
  }
}
